import './as-header-set.ts';
import '../../base/buttons/as-icon-button';
import styleText from './as-state-set.css?raw';

/**
 * State management section component
 */
export class TrStateSet extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();
  private configurator?: any;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      TrStateSet.sheet
    ];
    
    this.shadowRoot!.innerHTML = /*html*/`
      <div set-id="header-state-set">
        <as-icon-button 
          file-name="header/undo.png" black
          tooltip-dict-key="tooltip.state.undo"
          tooltip-default-text="Undo"
          name="undo"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/redo.png" black
          tooltip-dict-key="tooltip.state.redo"
          tooltip-default-text="Redo"
          name="redo"
        ></as-icon-button>
      </div>
    `;

    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    const set = this.shadowRoot!.querySelector('tr-header-set');
    if (!set) return;

    const buttons = Array.from(set.children);
    const events = ['undo', 'redo'];

    buttons.forEach((button, index) => {
      button.addEventListener('header-button-clicked', () => {
        this.dispatchEvent(new CustomEvent(events[index], {
          bubbles: true,
          composed: true
        }));
      });
    });
  }

  connectedCallback() {
    // Listen for configurator creation
    document.addEventListener('as-cfgr-comp-ready', (event: CustomEvent) => {
      this.configurator = event.detail?.configurator;
    });

    // Handle state events
    this.addEventListener('undo', () => {
      this.configurator?.undo?.();
    });

    this.addEventListener('redo', () => {
      this.configurator?.redo?.();
    });
  }
}

customElements.define('as-state-set', TrStateSet); 
